<!-- Header -->
<div style="display: flex; justify-content: space-between; flex-shrink: 0;">
    <div mat-dialog-title>
        {{headerText | translate}}
    </div>
    <div style="padding: 10px">
        <tyl-form-field label="View" *ngIf="V10" style="margin-right:20px;">
            <mat-select id="viewField" [(ngModel)]="selectedView" [disabled]="disableView"
                (selectionChange)="setSelectedView(selectedView)">
                <mat-option *ngFor="let item of viewOptions; let i = index;" id="viewFieldOption{{i}}" [value]="item">
                    {{item.display}}
                </mat-option>
            </mat-select>
        </tyl-form-field>
        <tyl-form-field label="Show classes for" style="width: 260px">
            <mat-select id="termField" [(ngModel)]="selectedTerm" (selectionChange)="setSelectedTerm(selectedTerm)">
                <mat-option *ngFor="let term of terms; let i = index;" id="termFieldOption{{i}}" [value]="term">
                    {{term.CodeDescription}}
                </mat-option>
            </mat-select>
        </tyl-form-field>
    </div>
</div>



<!-- Body -->
<mat-dialog-content style="width: 70vw; height: 65vh;">

    <!-- Classes Table -->
    <mat-table matSort [dataSource]="tableData">

        <!-- Select Column -->
        <ng-container matColumnDef='select'>
            <mat-header-cell *matHeaderCellDef>
                <!-- Select -->
                <tyl-checkbox [checked]="selectAllCourse" (change)="setSelectAllCourse()"
                    (click)="$event.stopPropagation()" id="allCourse{{i}}Checkbox"></tyl-checkbox>
            </mat-header-cell>
            <mat-cell *matCellDef="let course; let i = index;">
                <tyl-checkbox [checked]="selectedCourses.includes(course)" (change)="selectCourse(course)"
                    (click)="$event.stopPropagation()" id="course{{i}}Checkbox"></tyl-checkbox>
            </mat-cell>
        </ng-container>

        <!-- Meets Column -->
        <ng-container matColumnDef='meets'>
            <mat-header-cell *matHeaderCellDef mat-sort-header="Meets" translate>
                Meets
                <filter [data]="tableData" columnName="Meets" dataType="string" id="meetsFilter" class="mat-filter">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let course">
                {{course.Meets}}
            </mat-cell>
        </ng-container>

        <!-- Term Column -->
        <ng-container matColumnDef='term'>
            <mat-header-cell *matHeaderCellDef mat-sort-header="Term" translate>
                Term
                <filter [data]="tableData" columnName="Site" dataType="string" id="termFilter" class="mat-filter">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let course">
                {{course.Term}}
            </mat-cell>
        </ng-container>

        <!-- Course-Section Column -->
        <ng-container matColumnDef='course section'>
            <mat-header-cell *matHeaderCellDef mat-sort-header="CourseSection" translate>
                Course-Section
                <filter [data]="tableData" columnName="CourseSection" dataType="string" id="sectionFilter"
                    class="mat-filter"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let course">
                {{course.CourseSection}}
            </mat-cell>
        </ng-container>

        <!-- Course Name Column -->
        <ng-container matColumnDef='course name'>
            <mat-header-cell *matHeaderCellDef mat-sort-header="Course" translate>
                Course Name
                <filter [data]="tableData" columnName="Course" dataType="string" id="courseFilter" class="mat-filter">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let course">
                {{course.Course}}
            </mat-cell>
        </ng-container>

        <!-- Instructor Column -->
        <ng-container matColumnDef='instructor'>
            <mat-header-cell *matHeaderCellDef mat-sort-header="Instructor" translate>
                Instructor
                <filter [data]="tableData" columnName="Instructor" dataType="string" id="instructorFilter"
                    class="mat-filter"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let course">
                {{course.Instructor}}
            </mat-cell>
        </ng-container>

        <!-- Room Column -->
        <ng-container matColumnDef='room'>
            <mat-header-cell *matHeaderCellDef mat-sort-header="Room" translate>
                Room
                <filter [data]="tableData" columnName="Room" dataType="string" id="roomFilter" class="mat-filter">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let course">
                {{course.Room}}
            </mat-cell>
        </ng-container>

        <!-- Enrolled Column -->
        <ng-container matColumnDef='enrolled'>
            <mat-header-cell *matHeaderCellDef mat-sort-header="Enrolled" translate>
                Enrolled
                <filter [data]="tableData" columnName="Enrolled" dataType="number" id="enrolledFilter"
                    class="mat-filter"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let course" style="padding-right: 23px;">
                {{course.Enrolled}}
            </mat-cell>
        </ng-container>

        <!-- Profile Column -->
        <ng-container matColumnDef='profile'>
            <mat-header-cell *matHeaderCellDef mat-sort-header="Profile" translate>
                Class Information
                <filter [data]="tableData" columnName="CourseHasProfile" dataType="boolean" id="courseHasProfileFilter"
                    class="mat-filter" trueValue="true" falseValue="false"></filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let course" style="text-align: center">
                {{course.CourseHasProfile ? 'Y' : ''}}
            </mat-cell>
        </ng-container>

        <!-- Seating Chart Column -->
        <ng-container matColumnDef='seating chart'>
            <mat-header-cell *matHeaderCellDef mat-sort-header="SeatingCharts" translate>
                Seating Chart
            </mat-header-cell>
            <mat-cell *matCellDef="let course" style="text-align: center">
                {{course.SeatingCharts != 0 ? course.SeatingCharts : ''}}
            </mat-cell>
        </ng-container>

        <!-- Gradebook Updated Column -->
        <ng-container matColumnDef='gradebook updated'>
            <mat-header-cell *matHeaderCellDef mat-sort-header="UpdatedDate" translate>
                Gradebook Updated
            </mat-header-cell>
            <mat-cell *matCellDef="let course">
                {{course.UpdatedDate | date: 'MM/dd/yy'}}
            </mat-cell>
        </ng-container>

        <!-- Row Definitions -->
        <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columns;" style="cursor: pointer" (click)="selectCourse(row)" matRipple>
        </mat-row>
    </mat-table>

    <!-- Spinner -->
    <div *ngIf="spinner" class="spinnerOverlay">
        <mat-spinner></mat-spinner>
    </div>
</mat-dialog-content>



<!-- Footer -->
<mat-dialog-actions>

    <!-- Left Hand Buttons -->
    <div class="flex-footer-left">
        <!--
			<tyl-button [image]="filtered() ? 'filter yellow.png' : 'filter.png'"
				label="Filter"
				(clickEvent)="showFilter.emit()"></tyl-button>
			-->
    </div>

    <!-- Filter Notification -->
    <div class="flex-footer-middle" style="align-items: center" translate>
        <filter-notification [filtered]="filtered()" (filter)="showFilter.emit(true)" (clearFilter)="clearFilter()">
        </filter-notification>
    </div>

    <!-- Right Hand Buttons -->
    <div class="flex-footer-right">
        <tyl-button *ngIf="multiselect" image="save.png" label="Save" (clickEvent)="save()"></tyl-button>
        <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="cancel()"></tyl-button>
    </div>
</mat-dialog-actions>

<!-- Filter -->
<!-- <classroom-summary-filter [courseSource]="tableData"
	[showFilter]="showFilter"
	(filterChange)="filter($event)"></classroom-summary-filter> -->